export default __webpack_public_path__ + "static/media/vol7_1.51ad5585.png";